// extracted by mini-css-extract-plugin
export default {"wrapper":"IndicatorView_wrapper__PU5NC","grid":"IndicatorView_grid__j8HTe"};